<template>
    <div id="worksends-app" style="overflow: auto">
        <div id="survey-details" class="survey-public tw-w-full tw-block tw-h-full">
            <div class="worksends-main questions tw-w-full tw-h-full">
                <div v-if="isPreview" class="survey-top-bar"><b>Survey Preview:</b> The answers will not be saved.</div>
                <page-view v-if="currentPage" class="tw-h-full editor-wrap" public="public" :page="currentPage" :styles="survey.theme?.styles || {}"/>
            </div>
        </div>
    </div>
</template>

<script>

import PageView from "@/pages/surveys/PageView";

export default {
    name: 'SurveyResponseForm',
    components: {PageView},
    data() {
        return {
            showSourceModal: false,
            answers: {},
        }
    },
    computed: {
        survey() {
            return this.$store.getters["surveys/selected"];
        },
        pages() {
            return this.$store.getters["surveyPages/orderedList"];
        },
        currentPage() {
            return this.$store.getters["surveyPages/selected"];
        },
        response() {
            return this.$store.getters["surveyResponses/selected"];
        },
        isPreview() {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get('preview') !== null;
        },
    },
    created() {
        this.fetchSurvey(this.$route.params.team, this.$route.params.slug)
    },
    methods: {
        async fetchSurvey(team, slug) {
            const {id} = await this.$store.dispatch('surveys/getBySlug', {team, slug, include: 'pages.questions,theme'});
            this.$store.commit('surveys/setSelected', id)
            document.title = this.survey.name;
            const responseId = localStorage.getItem(`${this.$route.params.slug}-response-id`);
            if (responseId) {
                try {
                    await this.$store.dispatch('surveyResponses/getById', responseId);
                    this.$store.commit('surveyResponses/setSelected', responseId);
                } catch {
                    localStorage.removeItem(`${this.$route.params.slug}-response-id`);
                }

            }
            if (!this.$store.state.surveyResponses.selected) {
                const {id} = await this.$store.dispatch('surveyResponses/create', {source: this.$route.params.source})
                this.$store.commit('surveyResponses/setSelected', id);
                localStorage.setItem(`${this.$route.params.slug}-response-id`, id);
            }

            if (this.pages.length) {
                await this.$store.dispatch('surveyPages/selectPage', this.pages[0]);
            }

            this.$store.commit('setCoreLoaded', true);
        },
    },
}
</script>
